<!--  -->
<template>
    <div class="success">
        <div class="success-container">
            <div class="success-icon">
                <svg viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" fill="#e8f4ff" stroke="none" />
                    <path fill="none" stroke="var(--primary)" stroke-width="6" stroke-linecap="round"
                        stroke-linejoin="round" d="M30 52l15 15 25-25" style="stroke-dasharray: 100;
                             stroke-dashoffset: 100;
                             animation: checkmark 0.8s ease-out forwards;
                             animation-delay: 0.3s" />
                </svg>
            </div>

            <h1 class="success-title">提交成功!</h1>

            <p class="success-message">
                提交成功！我们已成功收到您的问卷反馈。
            </p>

            <!-- <div class="action-buttons">
                <a href="https://www.bjia.org/" class="btn">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                    </svg>
                    返回首页
                </a>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'success',
        data() {
            //这里存放数据
            return {

            }
        },
        components: {},

        //方法集合
        methods: {

        },
        created() {

        },
        mounted() {
 document.title='调查问卷'
        }
    }
</script>
<style>
    :root {
        --primary: #4179d2;
        --light-bg: #f8f9fc;
    }

    .success {
        margin: 0;
        min-height: 100vh;
        display: flex;
        align-items: center;
        background: var(--light-bg);
        font-family: 'Microsoft YaHei', sans-serif;
    }

    .success-container {
        /* max-width: 1000px; */
       width: 800px;
        margin: 50px auto;
        padding: 20px;
        text-align: center;
        background: white;
        border-radius: 30px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
        position: relative;
    }

    .success-icon {
        width: 140px;
        height: 140px;
        margin: 30px auto;
        animation: float 3s ease-in-out infinite;
    }

    @keyframes float {

        0%,
        100% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(-8px);
        }
    }

    @keyframes checkmark {
        from {
            stroke-dashoffset: 100;
        }

        to {
            stroke-dashoffset: 0;
        }
    }

    .success-title {
        font-size: 40px;
        color: #1a237e;
        margin: 40px;
        font-weight: 600;
    }

    .success-message {
        color: #616161;
        font-size: 30px;
        line-height: 40px;
        margin: 0 auto 20px;
        /* max-width: 480px; */
    }

    .action-buttons {
        display: flex;
        justify-content: center;
    }

    .btn {
        padding: 20px 60px;
        /* padding: 0.9rem 2.5rem; */
        border-radius: 8px;
        text-decoration: none;
        font-weight: 500;
        transition: all 0.2s;
        background: var(--primary);
        color: white;
        box-shadow: 0 4px 14px rgba(65, 121, 210, 0.3);
        border: none;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(65, 121, 210, 0.4);
    }
</style>